// extracted by mini-css-extract-plugin
module.exports = {"link":"default_link__VP3cM","iFrameWithLink":"default_iFrameWithLink__mqwAo"};